import { useTheme } from "../lib/content";

/** ThemeProvider — injects an inline <style> tag that overrides the
 * hardcoded Tailwind arbitrary-color classes used across the site
 * (bg-[#E60000], text-[#1A1A1A], etc). Editing the theme from the
 * admin updates the whole site instantly without rebuild. */
export const ThemeProvider = ({ children }) => {
  const t = useTheme();
  // CSS — escape `[` `]` `#` per Tailwind class selector rules
  const css = `
    :root {
      --eg-accent: ${t.accent};
      --eg-accent-hover: ${t.accent_hover};
      --eg-dark: ${t.dark};
      --eg-dark-alt: ${t.dark_alt};
      --eg-light: ${t.light_bg};
      --eg-muted: ${t.muted_bg};
    }
    .bg-\\[\\#E60000\\] { background-color: var(--eg-accent) !important; }
    .hover\\:bg-\\[\\#B30000\\]:hover { background-color: var(--eg-accent-hover) !important; }
    .text-\\[\\#E60000\\] { color: var(--eg-accent) !important; }
    .hover\\:text-\\[\\#E60000\\]:hover { color: var(--eg-accent) !important; }
    .border-\\[\\#E60000\\] { border-color: var(--eg-accent) !important; }
    .hover\\:border-\\[\\#E60000\\]:hover { border-color: var(--eg-accent) !important; }
    .group:hover .group-hover\\:text-\\[\\#E60000\\] { color: var(--eg-accent) !important; }
    .group:hover .group-hover\\:border-\\[\\#E60000\\] { border-color: var(--eg-accent) !important; }
    .bg-\\[\\#1A1A1A\\] { background-color: var(--eg-dark) !important; }
    .text-\\[\\#1A1A1A\\] { color: var(--eg-dark) !important; }
    .hover\\:text-\\[\\#1A1A1A\\]:hover { color: var(--eg-dark) !important; }
    .group:hover .group-hover\\:text-\\[\\#1A1A1A\\] { color: var(--eg-dark) !important; }
    .bg-\\[\\#262626\\] { background-color: var(--eg-dark-alt) !important; }
    .hover\\:bg-\\[\\#2E2E2E\\]:hover { background-color: var(--eg-dark-alt) !important; filter: brightness(1.1); }
    .bg-\\[\\#F9F9F9\\] { background-color: var(--eg-light) !important; }
    .bg-\\[\\#F4F4F4\\] { background-color: var(--eg-muted) !important; }
  `;
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: css }} />
      {children}
    </>
  );
};

export default ThemeProvider;
